import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asOpportunity, listResults } from "../lib/thirdDoorAdapters";

export default function Opportunities() {
    const [query, setQuery] = useState("");
    const [stage, setStage] = useState("all");
    const { resources } = useModelIndex("anticipated_procurement" as any, { search: query, limit: 25 } as any);
    const rows = listResults(resources).map(asOpportunity);
    const filtered = useMemo(() => rows.filter((row) => {
      const matchQuery = row.title.toLowerCase().includes(query.toLowerCase());
      const matchStage = stage === "all" || row.status === stage;
      return matchQuery && matchStage;
    }), [query, stage]);
  return (
   <div className="w-full min-w-0 overflow-x-hidden">
      <div className="flex w-full min-w-0 flex-col gap-6">
          <section className="space-y-4">
      <h1 className="text-2xl font-semibold">Browse Opportunities</h1>
      <Card>
      <CardContent className="flex flex-wrap gap-3 p-4">
      <Input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search keyword" className="max-w-xs" />
      <Select value={stage} onValueChange={setStage}>
      <SelectTrigger className="w-44"><SelectValue placeholder="Stage" /></SelectTrigger>
      <SelectContent className="bg-popover text-popover-foreground">
      <SelectItem value="all">All stages</SelectItem>
      <SelectItem value="open">Open</SelectItem>
      <SelectItem value="closing">Closing soon</SelectItem>
      </SelectContent>
      </Select>
      <Button variant="outline" onClick={() => { setQuery(""); setStage("all"); }}>Reset</Button>
      </CardContent>
      </Card>
      <Card>
      <CardHeader><CardTitle>Results ({filtered.length})</CardTitle></CardHeader>
      <CardContent className="overflow-x-auto">
      <Table>
      <TableHeader><TableRow><TableHead>Opportunity</TableHead><TableHead>Status</TableHead><TableHead>Fit</TableHead><TableHead /></TableRow></TableHeader>
      <TableBody>
      {filtered.map((row) => (
      <TableRow key={row.id}>
      <TableCell>{row.title}</TableCell>
      <TableCell><Badge variant={row.status === "open" ? "secondary" : "outline"}>{row.status}</Badge></TableCell>
      <TableCell>{row.fit}%</TableCell>
      <TableCell><Button asChild size="sm"><Link to={`/opportunities/${row.id}`}>View</Link></Button></TableCell>
      </TableRow>
      ))}
      </TableBody>
      </Table>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}